import { Box, Divider, Stack, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import React, { useContext, useEffect, useRef, useState, useMemo } from "react";
import { Images } from "../../assets/common";
import {
  display,
  fullName,
  getErrorString,
  getUserDetail,
  getUserId,
  isOwnerId,
  truncate,
} from "../../constants/function";
import { SocketContext } from "../../context/socket";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import "./index.scss";
import { useDispatch, useSelector } from "react-redux";
import cookieStorage from "../../services/cookie-storage";
import OutsideClickHandler from "react-outside-click-handler";
import Picker from "emoji-picker-react";
import Message from "../Chat/Message";
import ChatInput from "../Chat/ChatInput";
import ChatUserSearch from "./chatUserSearch";
import ApiService from "../../services/api-service";
import notifier from "../Notifier";
import { getBalance } from "../../asyncAction/asyncBalance";
import TipPopup from "../TipPopup";
import NoData from "../Nodata";
import Loader from "../Loader";
import { hideChat } from "./../../action/chat";
import ChatTip from "./../../components/Chat/ChatTip";
import OnlineUsers from "../Chat/OnlineUsers";
import Online from "./../../components/Chat/online";
import ChatMoreData from "../Chat/ChatMoreData";
import NftList from "./nftList";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import { startStream } from "./../../action/stream";
import StreamingDetailPoup from "../Stream/StreamingDetailPoup";
import { useTranslation } from "react-i18next";
// Cache for chat data to avoid reloading
const chatDataCache = {
  data: null,
  timestamp: null,
  userId: null,
  CACHE_DURATION: 5 * 60 * 1000 // 5 minutes
};

// Memoized chat item component for better performance
const ChatUserItem = React.memo(({ topChat, index, onClick, userId }) => {
  const avatarSrc = useMemo(() => {
    if (topChat["PlaylistroomId"] && topChat["playlistDetails"]) {
      return topChat["playlistDetails"]["GIF"]
        ? topChat["playlistDetails"]["GIF"]["filePath"]
        : topChat["playlistDetails"]["thumbnailImg"]
        ? topChat["playlistDetails"]["thumbnailImg"]["filePath"]
        : Images.musicImg;
    }
    return topChat["otherUser"] && topChat["otherUser"]["profileImg"]
      ? topChat["otherUser"]["profileImg"]["filePath"]
      : Images.musicImg;
  }, [topChat]);

  const displayName = useMemo(() => {
    return topChat["PlaylistroomId"]
      ? truncate(topChat["playlistDetails"]["title"], 18)
      : truncate(fullName(topChat["otherUser"]), 18);
  }, [topChat]);

  const unseenCount = useMemo(() => {
    if (topChat["count"] && !topChat["PlaylistroomId"]) {
      return topChat["count"];
    }
    if (topChat["PlaylistroomId"] && topChat["unseen"] && topChat["unseen"][userId]) {
      return topChat["unseen"][userId];
    }
    return null;
  }, [topChat, userId]);

  return (
    <Box
      className="__chat_user_box_user"
      onClick={() => onClick(topChat, index)}
      data-username={displayName}
    >
      {unseenCount ? (
        <Box className="__chat_user_online_count">
          {unseenCount}
        </Box>
      ) : null}
      <img
        className="avatar"
        src={avatarSrc}
        alt={displayName}
      />
      <Box flex={1}>
        <Typography className="_fade-text-80 fs-14 font-weight-500">
          {displayName}
        </Typography>
      </Box>
      {topChat["otherUser"] && topChat["otherUser"]["isOnline"] ? (
        <Box
          sx={{
            position: "absolute",
            width: "10px",
            height: "10px",
            background: "var(--primary-color, #FFEE20)",
            right: "22px",
            top: "18px",
            borderRadius: "50%",
          }}
        />
      ) : null}
    </Box>
  );
});

export default function DirectChat(props) {
  console.log('[Chat Performance] DirectChat component mounting', {
    props,
    timestamp: new Date().toISOString()
  });
  
  const { t } = useTranslation("common");
  const { isStream } = useSelector((state) => state.stream);
  const [isStreamingPopup, setIsStreamingPopup] = React.useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const songs = useSelector((state) => state.songs);
  const [chosenEmoji, setChosenEmoji] = useState(null);
  const token = cookieStorage.getCookie("Authorization");
  const [typing, setTyping] = React.useState(false);
  const socket = useContext(SocketContext).Socket;
  const [message, setMessage] = useState("");
  const [openEmoji, setOpenEmoji] = useState(false);
  const [roomId, setRoomId] = useState(null);
  const [openUser, setOpenUser] = useState(false);
  const [openTip, setOpenTip] = React.useState(false);
  const [openPlaylistTip, setOpenPlaylistTip] = React.useState(false);
  const [userName, setUserName] = React.useState(null);
  const [chatIndex, setChatIndex] = React.useState(null);
  const online = useRef(null);
  let roomid = useRef(null);
  const topuser = useRef([]);
  const senderUserId = useRef(null);
  const userId = getUserId();
  const [loading, setLoading] = useState(false);
  const [topChats, setTopChats] = useState([]);
  const [newMessage, setNewMessage] = useState({});
  const [newUser, setNewUser] = useState({});
  const [load, setLoad] = useState(false);
  const [playlistRoomId, setPlaylistRoomId] = useState(null);
  const isPlaylistChat = useRef(null);
  const [showUsers, setShowUsers] = useState(false);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [more, setMore] = useState(false);
  const [showNft, setShowNft] = useState(false);
  const [status, setStatus] = useState(null);
  const [blockedBy, setBlockedBy] = useState(null);
  const joinTimeoutRef = useRef(null);
  // Set when the other person only takes messages from subscribers and the
  // viewer is not one. Checked when a direct chat opens; the socket's
  // dm-access-error covers the setting changing while the chat is open.
  const [dmLocked, setDmLocked] = useState(null);
  const {
    senderUserId: dmRecipientId,
    playlistroomId: dmPlaylistRoomId,
    timeStamp: dmOpenedAt,
    artistChat: dmFromProfile,
  } = props;

  useEffect(() => {
    setDmLocked(null);
    if (!dmRecipientId || dmPlaylistRoomId || !(dmOpenedAt || dmFromProfile)) return;
    let cancelled = false;
    ApiService.DM_ACCESS(dmRecipientId)
      .then((res) => {
        if (!cancelled && res?.result?.allowed === false) {
          setDmLocked({ recipientId: res.result.recipientId || dmRecipientId });
        }
      })
      .catch((error) => console.warn("[DM Chat] dm-access check failed", error));
    return () => {
      cancelled = true;
    };
  }, [dmRecipientId, dmPlaylistRoomId, dmOpenedAt, dmFromProfile]);

  useEffect(() => {
    if (!socket) return;
    const handleDmAccessError = (data) => {
      if (!data || data.roomId !== roomid.current) return;
      setDmLocked({ recipientId: data.recipientId || senderUserId.current });
      notifier.error(data.message || "Only subscribers can message this creator.");
    };
    socket.on("dm-access-error", handleDmAccessError);
    return () => socket.off("dm-access-error", handleDmAccessError);
  }, [socket]);
  const onEmojiClick = (emojiObject) => {
    if (emojiObject && emojiObject.emoji) {
      setChosenEmoji(emojiObject);
      setMessage((prevMessage) => prevMessage + emojiObject.emoji);
    }
  };
  useEffect(() => {
    if (!socket) return;

    const handleId = (msg) => {
      if (
        msg &&
        !roomid.current &&
        msg["senderUserId"] === senderUserId.current
      ) {
        if (joinTimeoutRef.current) {
          clearTimeout(joinTimeoutRef.current);
          joinTimeoutRef.current = null;
        }
        roomid.current = msg["roomId"];
        setRoomId(msg["roomId"]);
        setStatus(msg["status"]);
        setBlockedBy(msg?.blockedBy || null);
        for (let index = 0; index < topuser.current.length; index++) {
          const element = topuser.current[index];
          if (!element.roomId) {
            topuser.current[index].roomId = msg["roomId"];
            break;
          }
        }
      }
    };

    const handleOnlineUser = (u) => {
      setOnlineUsers([...u]);
    };

    socket.on("id", handleId);
    socket.on("onlineuser", handleOnlineUser);

    senderUserId.current = props["senderUserId"];

    return () => {
      socket.off("id", handleId);
      socket.off("onlineuser", handleOnlineUser);
    };
  }, [socket, props["senderUserId"]]);

  // Load chat list and register socket listeners for real-time updates
  React.useEffect(() => {
    if (topChats.length === 0 && userId) {
      getGroupChat(userId);
    }

    if (!socket) return;

    const handleMessageReceived = (msg) => {
      const userId = getUserId();
      if (msg.gift && msg["user"]._id === userId) return;

      // Invalidate cache when new message arrives
      chatDataCache.timestamp = null;
      const temp = topuser.current;
      const found = topuser.current.filter(
        (u) => msg["roomId"] === u["roomId"]
      );
      if (found.length === 0 && msg["senderUserId"] === getUserId()) {
        const user = getUserDetail();
        const newUser = {
          ChatroomType: "direct",
          ChatroomId: msg["roomId"],
          otherUser: msg["user"],
          recieverId: msg["user"]["_id"],
          roomId: msg["roomId"],
          online: true,
          count: 1,
          senderDetail: {
            firstName: user["firstName"],
            lastName: user["lastName"],
            profileImg: user["profileImg"],
            _id: user["_id"],
          },
          userDetails: msg["user"],
        };
        newUser["otherUser"]["isOnline"] = true;
        topuser.current.unshift(newUser);
        setTopChats([...topuser.current]);
      } else {
        for (let index = 0; index < topuser.current.length; index++) {
          if (
            topuser.current[index]["roomId"] === msg["roomId"] &&
            msg["user"]["_id"] !== senderUserId.current
          ) {
            temp[index]["msgId"] = msg["_id"];
            temp[index]["count"] = temp[index]["count"]
              ? temp[index]["count"] + 1
              : 1;
            temp[index]["otherUser"]["isOnline"] = true;

            // Move this chat to the top of the list
            const updatedChat = temp.splice(index, 1)[0];
            topuser.current = [updatedChat, ...temp];
            setTopChats([...topuser.current]);
            break;
          }
        }
      }
    };

    const handleReceived = (msg) => {
      const temp = topuser.current;
      const found = topuser.current.filter(
        (u) => msg["roomId"] === u["roomId"]
      );
      if (
        found.length === 0 &&
        msg["senderUserId"] === getUserId() &&
        !msg["livestreamMessage"]
      ) {
        const user = getUserDetail();
        const newUser = {
          otherUser: msg["user"],
          recieverId: msg["user"]["_id"],
          roomId: msg["roomId"],
          online: true,
          count: 1,
          senderDetail: {
            firstName: user["firstName"],
            lastName: user["lastName"],
            profileImg: user["profileImg"],
            _id: user["_id"],
          },
          userDetails: msg["user"],
        };
        topuser.current.push(newUser);
        setTopChats([...topuser.current]);
      } else {
        for (let index = 0; index < topuser.current.length; index++) {
          if (
            topuser.current[index]["roomId"] === msg["roomId"] &&
            msg["roomId"] !== roomid.current &&
            !msg["livestreamMessage"]
          ) {
            temp[index]["msgId"] = msg["_id"];
            temp[index]["unseen"][userId] = temp[index]["unseen"][userId]
              ? temp[index]["unseen"][userId] + 1
              : 1;
            setTopChats([...temp]);
            break;
          }
        }
      }
    };

    const handleUserDisconnected = (user) => {
      if (topuser.current) {
        for (let index = 0; index < topuser.current.length; index++) {
          const u = topuser.current[index];
          if (
            u["ChatroomType"] === "direct" &&
            u["otherUser"]["_id"] === user
          ) {
            const users = topuser.current;
            online.current = null;
            users[index]["otherUser"]["isOnline"] = false;
            setTopChats([...users]);
            topuser.current = users;
            break;
          }
        }
      }
    };

    const handleUserConnected = (user) => {
      if (topuser.current) {
        for (let index = 0; index < topuser.current.length; index++) {
          const u = topuser.current[index];
          if (
            u["ChatroomType"] === "direct" &&
            u["otherUser"]["_id"] === user
          ) {
            const users = topuser.current;
            online.current = users[index]["ChatroomId"];
            users[index]["otherUser"]["isOnline"] = true;
            setTopChats([...users]);
            topuser.current = users;
            break;
          }
        }
      }
    };

    const handleBlocked = (data) => {
      const curentUser = getUserId();
      if (
        (data.userId === curentUser && roomid.current === data.roomId) ||
        data.userId === curentUser
      ) {
        setStatus(data["status"]);
      }
      if (topuser.current && topuser.current.length) {
        for (let index = 0; index < topuser.current.length; index++) {
          const u = topuser.current[index];
          if (
            u["ChatroomType"] === "playlist" &&
            data["roomId"] === topuser.current[index]?.ChatroomId
          ) {
            const users = topuser.current;
            if (
              data.status === "blocked" &&
              users[index].blockList.indexOf(data.userId) < 0
            )
              users[index].blockList.push(data.userId);
            else if (
              data.status === "blocked" &&
              users[index].blockList.indexOf(data.userId) >= 0
            ) {
              const blockIdx = users[index].blockList.indexOf(data.userId);
              users[index].blockList.splice(blockIdx, 1);
            }
            setTopChats([...users]);
            topuser.current = users;
            break;
          }
        }
      }
    };

    socket.on("message_received", handleMessageReceived);
    socket.on("received", handleReceived);
    socket.on("user-disconnected", handleUserDisconnected);
    socket.on("user_connected", handleUserConnected);
    socket.on("blocked", handleBlocked);

    return () => {
      socket.off("message_received", handleMessageReceived);
      socket.off("received", handleReceived);
      socket.off("user-disconnected", handleUserDisconnected);
      socket.off("user_connected", handleUserConnected);
      socket.off("blocked", handleBlocked);
    };
  }, [socket]);
  React.useEffect(() => {
    console.log('[DM Chat] useEffect triggered for joining chat', {
      timeStamp: props["timeStamp"],
      playlistroomId: props["playlistroomId"],
      senderUserId: props["senderUserId"],
      artistChat: props?.artistChat
    });

    if (
      (props["timeStamp"] && !props["playlistroomId"]) ||
      (props["senderUserId"] && props?.artistChat)
    ) {
      //NOTE: joining direct chat
      console.log('[DM Chat] Joining direct chat, emitting joinDirect event', {
        userId,
        senderUserId: props["senderUserId"]
      });
      roomid.current = null;
      setRoomId(null);
      isPlaylistChat.current = false;

      // Clear any previous join timeout
      if (joinTimeoutRef.current) {
        clearTimeout(joinTimeoutRef.current);
        joinTimeoutRef.current = null;
      }

      socket.emit("joinDirect", {
        JWT: token,
        roomId: userId,
        senderUserId: props["senderUserId"],
      });

      // Timeout: if socket "id" event doesn't arrive within 10s, retry once
      const targetSender = props["senderUserId"];
      joinTimeoutRef.current = setTimeout(() => {
        if (!roomid.current && senderUserId.current === targetSender) {
          console.warn('[DM Chat] Socket "id" event timeout — retrying joinDirect');
          socket.emit("joinDirect", {
            JWT: token,
            roomId: userId,
            senderUserId: targetSender,
          });
        }
      }, 10000);
    } else if (props["timeStamp"] && props["playlistroomId"]) {
      //NOTE: joining playlist chat
      console.log('[DM Chat] Joining playlist chat', props["playlistroomId"]);
      setRoomId(props["playlistroomId"]);
      roomid.current = props["playlistroomId"];
      isPlaylistChat.current = true;
      getBlockedUserOfPlaylist(props["playlistroomId"]);
      socket.emit("join", { JWT: token, roomId: props["playlistroomId"] });
    }
  }, [props["timeStamp"], props["senderUserId"] && props?.artistChat]);
  useEffect(() => {
    return () => {
      if (isPlaylistChat) {
        socket.emit("forceDisconnect", {
          JWT: token,
          senderUserId: getUserId(),
          roomId: roomid.current,
        });
      }
      setMessage("");
      setOnlineUsers([]);
      setNewUser({});
      setPlaylistRoomId(null);
      setNewMessage({});
      setTopChats([]);
      if (joinTimeoutRef.current) {
        clearTimeout(joinTimeoutRef.current);
        joinTimeoutRef.current = null;
      }
    };
  }, []);

  const handleTip = async (amount, id, type, currency) => {
    if (amount) {
      setOpenTip(false);
      try {
        const payload = {
          id: id,
          tipAmount: amount,
          type: type,
          currency: currency,
        };
        setLoading(true);
        const response = isPlaylistChat.current
          ? await ApiService.TIP_PLAYLIST(payload)
          : await ApiService.TIP_ARTIST(payload);
        setLoading(false);
        notifier.success(response["result"]);
        // setUserName(null);
        dispatch(getBalance());

        // NOTE Tip message now handled by backend
        // const user = getUserDetail();

        // if (isPlaylistChat.current) {
        //   const msg = {
        //     roomId: roomid.current,
        //     senderUserId: senderUserId.current,
        //     message: `${fullName(
        //       user
        //     )} has tipped ${amount} ${currency.toUpperCase()} `,
        //     _id: userId,
        //     JWT: token,
        //     type: "tip",
        //   };
        //   socket.emit("chat_message", msg);
        // } else {
        //   const userData = getUserDetail();
        //   const msg = {
        //     roomId: roomid.current,
        //     senderUserId: senderUserId.current,
        //     message: `${fullName(
        //       user
        //     )} has tipped ${amount} ${currency.toUpperCase()} `,
        //     _id: userData._id,
        //     JWT: token,
        //     type: "tip",
        //   };
        //   msg["user"] = {
        //     firstName: userData["firstName"],
        //     lastName: userData["lastName"],
        //     profileImg: userData["profileImg"],
        //     _id: userData["_id"],
        //   };
        //   msg["_id"] = new Date().getTime();
        //   msg["createdAt"] = new Date();
        //   socket.emit("send", msg);
        //   setNewMessage({ ...msg });
        // }
      } catch (error) {
        setLoading(false);
        notifier.error(getErrorString(error));
      }
    } else {
      setOpenTip(false);
    }
  };
  const handleSelection = (senderId) => {
    setOpenUser(false);
  };
  const addNewUser = (chat, playlistroomId) => {
    setNewUser(chat);
    if (!playlistroomId) {
      const found = topuser.current.filter(
        (u) => u["otherUser"] && u["otherUser"]["_id"] === chat["_id"]
      );
      if (found.length > 0) {
        return;
      } else {
        const user = getUserDetail();
        const newUser = {
          ChatroomType: "direct",
          otherUser: {
            firstName: chat["firstName"],
            lastName: chat["lastName"],
            profileImg: chat["profileImg"],
            isOnline: chat["isOnline"],
            _id: chat["_id"],
          },
          recieverId: chat["_id"],
          roomId: null,
          senderDetail: {
            firstName: user["firstName"],
            lastName: user["lastName"],
            profileImg: user["profileImg"],
            _id: user["_id"],
          },
          userDetails: chat,
        };
        // const topchat = topChats;
        // topchat.push(newUser);
        // setTopChats([...topchat]);
        topuser.current.unshift(newUser);
        // online.current = chat["_id"];
        setTopChats([...topuser.current]);
        setChatIndex(0);
      }
    } else {
      const found = topuser.current.filter(
        (u) => u["PlaylistroomId"] === chat["_id"]
      );
      if (found.length > 0) {
        const index = topuser.current.findIndex(
          (el) => el.PlaylistroomId === chat._id
        );
        setChatIndex(index);
        return;
      } else {
        const user = getUserDetail();
        const newUser = {
          otherUser: {},
          recieverId: chat["_id"],
          roomId: null,
          senderDetail: {
            firstName: user["firstName"],
            lastName: user["lastName"],
            profileImg: user["profileImg"],
            _id: user["_id"],
          },
          blockList: [],
          ChatroomId: chat["_id"],
          ChatroomType: "playlist",
          PlaylistroomId: chat["_id"],
          playlistDetails: chat,
          onlineStatus: true,
          roomId: chat["_id"],
          unseen: null,
          userDetails: chat,
        };
        // const topchat = topChats;
        // topchat.push(newUser);
        // setTopChats([...topchat]);
        const playlistNftDetails = newUser?.playlistDetails?.playlistNftDetails;
        if (playlistNftDetails?.owner)
          newUser.playlistDetails.owner = playlistNftDetails.owner;
        if (newUser?.playlistDetails)
          newUser.nftDetails = {
            onAuction: playlistNftDetails?.onAuction ?? false,
            onSale: playlistNftDetails?.onSale ?? false,
          };
        topuser.current.unshift(newUser);
        setTopChats([...topuser.current]);
        setChatIndex(0);
      }
    }
  };
  const getGroupChat = async (userId) => {
    const startTime = performance.now();
    console.log('[Chat Performance] getGroupChat started', {
      userId,
      timestamp: new Date().toISOString()
    });
    
    // Validate userId before making API call
    if (!userId || userId === 'undefined' || userId === 'null') {
      console.warn('[Chat] Invalid userId, skipping chat data fetch:', userId);
      setLoad(false);
      return;
    }
    
    // Check global cache first (from preload)
    const now = Date.now();
    if (window.__chatDataCache && 
        window.__chatDataCache.userId === userId && 
        window.__chatDataCache.timestamp && 
        (now - window.__chatDataCache.timestamp) < chatDataCache.CACHE_DURATION) {
      console.log('[Chat Performance] Using preloaded chat data', {
        age: now - window.__chatDataCache.timestamp,
        cachedChats: window.__chatDataCache.data.length
      });
      setTopChats(window.__chatDataCache.data);
      topuser.current = [...window.__chatDataCache.data];
      chatDataCache.data = window.__chatDataCache.data;
      chatDataCache.timestamp = window.__chatDataCache.timestamp;
      chatDataCache.userId = userId;
      setLoad(false);
      return;
    }
    
    // Check local cache
    if (chatDataCache.data && 
        chatDataCache.userId === userId && 
        chatDataCache.timestamp && 
        (now - chatDataCache.timestamp) < chatDataCache.CACHE_DURATION) {
      console.log('[Chat Performance] Using cached chat data', {
        age: now - chatDataCache.timestamp,
        cachedChats: chatDataCache.data.length
      });
      setTopChats(chatDataCache.data);
      topuser.current = [...chatDataCache.data];
      setLoad(false);
      return;
    }
    
    try {
      setLoad(true);

      // Race the API call against a 15s timeout
      const apiPromise = ApiService.GROUP_CHAT_V2(userId);
      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error('Chat list request timed out')), 15000)
      );
      const response = await Promise.race([apiPromise, timeoutPromise]);

      console.log('[Chat Performance] GROUP_CHAT_V2 API response received', {
        duration: performance.now() - startTime,
        oneToOneChatCount: response["result"]["oneToOneChatData"]?.length || 0,
        playlistChatCount: response["result"]["playlistChat"]?.length || 0,
        fullResponse: response
      });
      
      const oneToOneChatData = response["result"]["oneToOneChatData"] || [];
      const playlistChat = response["result"]["playlistChat"] || [];

      // Process data in batches for better performance
      const allChats = [...oneToOneChatData, ...playlistChat];
      
      // Set initial batch immediately for faster perceived loading
      if (allChats.length > 10) {
        setTopChats(allChats.slice(0, 10));
        
        // Load rest after a short delay
        setTimeout(() => {
          setTopChats(allChats);
          topuser.current = [...allChats];
        }, 100);
      } else {
        setTopChats(allChats);
        topuser.current = [...allChats];
      }
      
      // Update both local and global cache
      chatDataCache.data = allChats;
      chatDataCache.timestamp = Date.now();
      chatDataCache.userId = userId;
      
      // Update global cache for other components
      window.__chatDataCache = {
        data: allChats,
        timestamp: Date.now(),
        userId: userId
      };
      
      setLoad(false);
      console.log('[Chat Performance] getGroupChat completed', {
        totalDuration: performance.now() - startTime,
        totalChats: allChats.length
      });
    } catch (error) {
      console.error('[Chat Performance] getGroupChat error', error);
      console.error("Error loading chat data:", error);
      notifier.error("Failed to load chat messages. Please try again.");
      setLoad(false);
      setTopChats([]);
      topuser.current = [];
    }
  };

  const handleTilteClick = () => {
    if (isPlaylistChat.current) history.push(`/app/Music/${roomid.current}`);
    else history.push(`/app/ArtistProfile/${newUser["_id"]}`);
  };
  useEffect(() => {}, [status]);
  const getBlockedUserOfPlaylist = async (roomid) => {
    try {
      const response = await ApiService.BLOCKER_USER(roomid);
      setStatus(response?.result?.isBlocked ? "blocked" : "active");
    } catch (error) {}
  };

  // Memoized chat item click handler
  const handleChatItemClick = React.useCallback((topChat, index) => {
    if (chatIndex === index) {
      return;
    }

    setNewUser(topChat["otherUser"] ? topChat["otherUser"] : {});
    online.current = topChat["otherUser"] ? topChat["ChatroomId"] : null;
    setChatIndex(index);
    
    setTopChats(topChats.map((chat, i) => {
      if (i !== index) return chat;
      const updated = { ...chat, count: undefined };
      if (updated["unseen"]) updated["unseen"] = { ...updated["unseen"], [userId]: 0 };
      return updated;
    }));
    
    setRoomId(null);
    const userName = topChat["PlaylistroomId"]
      ? topChat["playlistDetails"]["title"]
      : fullName(topChat["otherUser"]);
    const userid = topChat["PlaylistroomId"]
      ? topChat["PlaylistroomId"]
      : topChat["otherUser"]["_id"];
    
    props.senndUserId(
      userName,
      userid,
      new Date().getTime(),
      topChat["PlaylistroomId"]
    );
    
    setUserName(userName);
    setPlaylistRoomId(topChat["PlaylistroomId"]);
    isPlaylistChat.current = topChat["PlaylistroomId"] ? true : false;
    setOpenUser(false);
    setShowNft(false);
    setStatus(
      topChat["PlaylistroomId"] &&
      topChat["blockList"].length > 0 &&
      topChat["blockList"].indexOf(getUserId()) >= 0
        ? "blocked"
        : "active"
    );
    setMore(false);
  }, [chatIndex, topChats, userId, props]);

  return (
    <Box
      className={
        "__chat_container_direct" +
        (songs && songs["songs"].length > 0
          ? " __chat_container_with_song_artist"
          : "")
      }
    >
      <Box className="__chat">
        <Box className="__chat_header">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
              position="relative"
            >
              <Typography
                onClick={() => handleTilteClick()}
                title={
                  props["title"] && props["title"].length > 20
                    ? props["title"]
                    : ""
                }
                className="fs-20 text-capitalize _cp"
                sx={{
                  fontFamily: "var(--font-body)",
                  fontWeight: 700,
                  letterSpacing: '-0.5px'
                }}
              >
                {truncate(props["title"], 20)}
              </Typography>

              {/*  */}
              {/* {isPlaylistChat.current && roomid.current ? (
                <Online
                  playListId={roomid.current}
                  onClick={(onlineUsers) => {
                    setOpenPlaylistTip(false);
                    setMore(false);
                    setShowUsers(true);
                    setOnlineUsers(onlineUsers);
                  }}
                  online="true"
                  className="_cp"
                />
              ) : null} */}
            </Stack>
            <CloseIcon
              sx={{ zIndex: "10000", marginLeft: "auto" }}
              className="_cp __chat_close"
              onClick={() => {
                dispatch(hideChat(false));
                props.onOutsideClick();
              }}
              color="default"
            />
          </Stack>
        </Box>
        <Divider className="__chat_header_divider" />
        {!openTip &&
        !openPlaylistTip &&
        !showUsers &&
        !more &&
        isPlaylistChat.current ? (
          <img
            className="_chat_tippers_icon"
            src={Images.chat_drop}
            alt="chat_drop"
            onClick={() => {
              setMore(true);
            }}
          />
        ) : null}
        {openPlaylistTip ? (
          <ChatTip
            songs={[]}
            playlistId={roomid.current}
            onClose={() => setOpenPlaylistTip(false)}
          />
        ) : null}
        {showUsers ? (
          <OnlineUsers
            users={onlineUsers}
            playListId={props["playListId"]}
            onClose={() => setShowUsers(false)}
          />
        ) : null}
        {showNft ? (
          <NftList
            onClose={() => setShowNft(false)}
            fullName={props["title"]}
            toUser={newUser["_id"] ?? props?.senderUserId}
          />
        ) : null}
        {more ? (
          <ChatMoreData
            playlistId={roomid.current}
            onClose={() => setMore(false)}
          />
        ) : null}
        <Stack spacing={1} sx={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
          {roomId && !openUser ? (
            <Message
              status={status}
              roomId={roomid.current}
              playListId={playlistRoomId}
              type={playlistRoomId ? "group" : "direct"}
              senderUserId={senderUserId.current}
              newMessage={newMessage}
              // clearMsg={() => setNewMessage()}
              close={() => {
                setRoomId(null);
                roomid.current = null;
                setNewMessage({});
              }}
              onChangeStatus={(status) => {
                setStatus(status);
              }}
            />
          ) : (
            <Box>
              <NoData
                lable={
                  !props["senderUserId"]
                    ? t("noData.message10")
                    : t("noData.message9")
                }
              />
            </Box>
            // null
          )}
        </Stack>
        <Box className="__chat_typing">
        </Box>

        {status === "blocked" ? (
          <Stack
            direction="row"
            justifyContent="center"
            align="center"
            className="__chat_send"
          >
            <Typography
              sx={{
                color: "var(--text-secondary, #5a5a5a)",
                display: "flex",
                alignItems: "center",
                cursor: "default",
              }}
            >
              {isPlaylistChat.current
                ? "Blocked from owner"
                : isOwnerId(blockedBy)
                ? "Unblock user"
                : "Blocked"}
            </Typography>
          </Stack>
        ) : dmLocked && !isPlaylistChat.current ? (
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            gap={1.5}
            className="__chat_send"
          >
            <Typography className="fs-14" sx={{ color: "var(--text-secondary, #9A9AB0)" }}>
              Only subscribers can message {userName || props["title"] || "this creator"}
            </Typography>
            <Typography
              className="_cp fs-14"
              sx={{ color: "var(--primary-color, #FFEE20)", fontWeight: 600 }}
              onClick={() => {
                dispatch(hideChat(false));
                props.onOutsideClick();
                history.push(`/app/ArtistProfile/${dmLocked.recipientId}`);
              }}
            >
              Subscribe
            </Typography>
          </Stack>
        ) : (
          <Stack direction="row" className="__chat_send">
            {/* Gift NFT button temporarily hidden */}
            {/* {!isPlaylistChat.current && roomid.current ? (
              <img
                aria-label="Gift nft"
                className="__chat_gift _cp"
                title="gift nft"
                src={Images.GIFT}
                alt="gift"
                onClick={() => setShowNft(true)}
                onClose={() => setShowNft(false)}
              />
            ) : null} */}
            {isPlaylistChat.current || roomid.current ? (
              <>
                <img
                  title="Tip"
                  aria-label="tip"
                  className="__chat_tip _cp"
                  src={Images.tip_player}
                  alt="tip"
                  onClick={() => setOpenTip(true)}
                />
                <Box position="relative" className="__chat_emoji_wrapper">
                  <img
                    aria-label="emoji"
                    title="Open emoji"
                    className="__chat_emoji _cp"
                    src={Images.emoji}
                    alt="emoji"
                    onClick={() => {
                      setOpenEmoji(!openEmoji);
                    }}
                  />
                  {openEmoji && (
                    <Box
                      sx={{
                        position: "absolute",
                        bottom: "40px",
                        right: "0",
                        zIndex: 1000,
                      }}
                    >
                      <OutsideClickHandler onOutsideClick={() => setOpenEmoji(false)}>
                        <Picker
                          onEmojiClick={onEmojiClick}
                          searchPlaceHolder="Search emoji..."
                          width={350}
                          height={400}
                          previewConfig={{ showPreview: false }}
                        />
                      </OutsideClickHandler>
                    </Box>
                  )}
                </Box>
              </>
            ) : null}

            {roomId ? (
              <ChatInput
                status={status}
                roomId={playlistRoomId ? playlistRoomId : roomId}
                playListId={playlistRoomId}
                type={playlistRoomId ? "group" : "direct"}
                message={message}
                senderUserId={props["senderUserId"]}
                onSendMessage={(msg) => {
                  setNewMessage({ ...msg });
                  setMessage("");
                }}
                cleanEmoji={() => setMessage("")}
              />
            ) : null}
          </Stack>
        )}
      </Box>
      <Box className="__chat_user_container pos_r">
        {isPlaylistChat.current &&
        chatIndex !== null &&
        isOwnerId(topuser.current[chatIndex]?.playlistDetails?.owner) &&
        !isStream &&
        !topuser.current[chatIndex]?.nftDetails?.onSale &&
        !topuser.current[chatIndex]?.nftDetails?.onAuction ? (
          <Stack
            alignItems="center"
            sx={{ paggingTop: "10px", cursor: "pointer" }}
            onClick={
              () => setIsStreamingPopup(true)
              // dispatch(
              //   startStream({
              //     streamData: topuser.current[chatIndex]?.playlistDetails,
              //     title: null,
              //     goal: null,
              //   })
              // )
              // : setIsStreamingPopup(false)
            }
          >
            <img style={{ width: "32px" }} src={Images.streaming} alt="" />
          </Stack>
        ) : null}

        {props?.artistChat ? null : (
          <>
            <Box className="__chat_user_box">
              {load && topChats.length === 0 ? (
                // Show skeleton loader while loading
                <div className="chat-list-skeleton">
                  {[1, 2, 3, 4, 5, 6].map((item) => (
                    <div key={item} className="skeleton-item">
                      <div className="skeleton-avatar"></div>
                      <div className="skeleton-content">
                        <div className="skeleton-name"></div>
                        <div className="skeleton-message"></div>
                      </div>
                      <div className="skeleton-time"></div>
                    </div>
                  ))}
                </div>
              ) : topChats &&
                topChats.map((topChat, index) => (
                  <Box
                    key={index}
                    className="__chat_user_box_user"
                    onClick={() => {
                      console.log('[DM Chat] Chat user clicked', { index, chatIndex, topChat });

                      if (
                        chatIndex === index
                        // ||
                        // (newUser && newUser["_id"] === topChat["otherUser"]["_id"])
                      ) {
                        console.log('[DM Chat] Already viewing this chat, skipping');
                        return;
                      }

                      setNewUser(
                        topChat["otherUser"] ? topChat["otherUser"] : {}
                      );
                      online.current = topChat["otherUser"]
                        ? topChat["ChatroomId"]
                        : null;
                      setChatIndex(index);
                      setTopChats(topChats.map((chat, i) => {
                        if (i !== index) return chat;
                        const updated = { ...chat, count: undefined };
                        if (updated["unseen"]) updated["unseen"] = { ...updated["unseen"], [userId]: 0 };
                        return updated;
                      }));
                      setRoomId(null);
                      const userName = topChat["PlaylistroomId"]
                        ? topChat["playlistDetails"]["title"]
                        : fullName(topChat["otherUser"]);
                      const userid = topChat["PlaylistroomId"]
                        ? topChat["PlaylistroomId"]
                        : topChat["otherUser"]["_id"];

                      console.log('[DM Chat] Calling senndUserId callback', { userName, userid, isPlaylist: !!topChat["PlaylistroomId"] });
                      props.senndUserId(
                        userName,
                        userid,
                        new Date().getTime(),
                        topChat["PlaylistroomId"]
                      );
                      setUserName(userName);
                      setPlaylistRoomId(topChat["PlaylistroomId"]);
                      isPlaylistChat.current = topChat["PlaylistroomId"]
                        ? true
                        : false;
                      setOpenUser(false);
                      setShowNft(false);
                      setStatus(
                        topChat["PlaylistroomId"] &&
                          topChat["blockList"].length > 0 &&
                          topChat["blockList"].indexOf(getUserId()) >= 0
                          ? "blocked"
                          : "active"
                      );
                      setMore(false);
                    }}
                  >
                    {topChat["count"] && !topChat["PlaylistroomId"] ? (
                      <Box className="__chat_user_online_count">
                        {topChat["count"]}
                      </Box>
                    ) : topChat["PlaylistroomId"] &&
                      topChat["unseen"] &&
                      topChat["unseen"][userId] ? (
                      <Box className="__chat_user_online_count">
                        {topChat["unseen"][userId]}
                      </Box>
                    ) : null}
                    <img
                      className="avatar"
                      src={
                        topChat["PlaylistroomId"] && topChat["playlistDetails"]
                          ? topChat["playlistDetails"]["GIF"]
                            ? topChat["playlistDetails"]["GIF"]["filePath"]
                            : topChat["playlistDetails"]["thumbnailImg"]
                            ? topChat["playlistDetails"]["thumbnailImg"][
                                "filePath"
                              ]
                            : Images.circle_playlist
                          : topChat["otherUser"] &&
                            topChat["otherUser"]["profileImg"]
                          ? topChat["otherUser"]["profileImg"]["filePath"]
                          : Images.default_user
                      }
                      alt=""
                    />
                    {/* NOTE: compressed online status*/}
                    {topChat["ChatroomType"] === "direct" ? (
                      <Box
                        className="__chat_user_online"
                        sx={{
                          backgroundColor:
                            topChat["ChatroomType"] === "direct" &&
                            topChat["otherUser"] &&
                            topChat["otherUser"]["isOnline"]
                              ? "var(--success-color, #2CF488)"
                              : "rgba(var(--text-secondary-rgb, 153, 153, 153), 0.6)",
                        }}
                      ></Box>
                    ) : null}
                  </Box>
                ))}
            </Box>
            <Box className="___">
              <Box
                className="__chat_user_new"
                onClick={() => {
                  setOpenUser(true);
                }}
              >
                <AddIcon className="__chat_add" sx={{ color: "var(--text-secondary, #999999)" }} />
              </Box>
            </Box>
          </>
        )}

        {load ? <Loader _class="__loader_inside" oldLoader /> : null}
      </Box>
      {openUser ? (
        <ChatUserSearch
          userId={userId}
          playlistId={roomid.current}
          senderUserId={newUser["_id"]}
          userName={userName}
          newUser={newUser}
          handleClose={(userName, userId, user, playlistroomId) =>
            userId && userName
              ? (setOpenUser(false),
                props.senndUserId(
                  userName,
                  userId,
                  new Date().getTime(),
                  playlistroomId
                ),
                setUserName(userName),
                setChatIndex(null),
                setPlaylistRoomId(playlistroomId),
                addNewUser(user, playlistroomId),
                setStatus("active"))
              : handleSelection(false)
          }
        />
      ) : null}
      {openTip ? (
        <TipPopup
          artist={userName}
          id={isPlaylistChat.current ? roomid.current : props["senderUserId"]}
          open={openTip}
          isArtist={isPlaylistChat.current ? false : true}
          isPlaylist={isPlaylistChat.current ? true : false}
          handleClose={handleTip}
        />
      ) : null}
      {loading ? (
        <Loader
          wait={true}
          message={t("loader.message10")}
          _class="__loader_inside"
        />
      ) : null}
      {isStreamingPopup ? (
        <StreamingDetailPoup
          open={isStreamingPopup}
          channelName={playlistRoomId}
          handleClose={(open, title, goal, goalDescription, isNew) =>
            open
              ? (dispatch(
                  startStream({
                    streamData: topuser.current[chatIndex]?.playlistDetails,
                    title: title,
                    goal: goal,
                    goalDescription: goalDescription,
                    isNew: isNew,
                  })
                ),
                setIsStreamingPopup(false))
              : setIsStreamingPopup(false)
          }
        />
      ) : null}
    </Box>
  );
}
